import { NgModule } from '@angular/core';
import { AutosizeDirective } from './autosize/autosize';
import { SettingsPopoverDirective } from './settings-popover/settings-popover';
@NgModule({
	declarations: [AutosizeDirective,
    SettingsPopoverDirective],
	imports: [],
	exports: [AutosizeDirective,
    SettingsPopoverDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts